/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { Button, IconButton, Skeleton, Tooltip } from "@mui/material";
import { HiPlus } from "react-icons/hi";
import SearchBar from "screens/leads/components/InputGrid";
import { BsFilter } from "react-icons/bs";
import { MdOutlineEdit } from "react-icons/md";
import { toast } from "react-toastify";
import { Loading } from "screens/perfilAutonomo/components/Loading";
import { RevendaComponentProps } from "screens/revenda/utils";
import * as S from "./style";
import { FooterTableEmpreendimentosRevenda } from "../FooterTable";
import { FiltroUnidadesRevenda } from "./filtro";
import { NovaRevendaModal } from "./novaRevenda/novaRevenda.component";
import {
  defaultFiltrosUnidadeEnvio,
  FiltrosUnidadeEnvio,
} from "./filtro/utils";
import { postRevendaUnidadeListar } from "./api/postRevendaUnidadeListar";
import { StatusReserva } from "./novaRevenda/utils";
import { getRevendaUnidade } from "./api/getRevendaUnidade";

export const UnidadesRevendaComponent: React.FC<RevendaComponentProps> = ({
  authToken,
}) => {
  const [filters, setFilters] = useState<FiltrosUnidadeEnvio>(
    defaultFiltrosUnidadeEnvio
  );
  const [data, setData] = useState<any[]>([]);
  const [edit, setEdit] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [loadingEdit, setLoadingEdit] = useState("");
  const [pagination, setPagination] = useState({
    paginaAtual: 1,
    totalItensRetorno: 10,
    countTotalPagination: 1,
  });
  const [open, setOpen] = useState({
    filters: false,
    novaRevenda: false,
  });

  const filtersSelected = Object.keys(filters)
    .filter((key) => key !== "nome")
    .reduce((count, key) => {
      const defaultValue =
        defaultFiltrosUnidadeEnvio[key as keyof FiltrosUnidadeEnvio];
      const currentValue = filters[key as keyof FiltrosUnidadeEnvio];

      if (Array.isArray(currentValue)) {
        return count + (currentValue.length > 0 ? 1 : 0);
      }

      if (typeof currentValue === "string") {
        return count + (currentValue !== "" ? 1 : 0);
      }

      return count + (currentValue !== defaultValue ? 1 : 0);
    }, 0);

  useEffect(() => {
    fetchUnidades({});
  }, []);

  const formatCurrency = (value: number) => {
    if (typeof value !== "number") return "";

    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const formatBoolean = (value: unknown) => {
    if (value === true) return "Sim";
    if (value === false) return "Não";
    return "--";
  };

  const handleFilters = (newFilters: FiltrosUnidadeEnvio) => {
    fetchUnidades({
      newFilters: { ...newFilters, nome: "" },
      newPagination: {
        ...pagination,
        paginaAtual: 1,
      },
    });
  };

  const handleEdit = (id: string) => {
    setLoadingEdit(id);

    getRevendaUnidade({ authToken, id })
      .then(({ success, data, notifications }) => {
        if (success) {
          setEdit(data);
          setOpen((prev) => ({ ...prev, novaRevenda: true }));
        } else throw new Error(notifications?.[0]?.message ?? "");
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          error?.message ? `Erro: ${error.message}` : "Erro ao buscar unidade"
        );
      })
      .finally(() => {
        setLoadingEdit("");
      });
  };

  const handleSearch = () => {
    setPagination((prev) => {
      const d = {
        ...prev,
        paginaAtual: 1,
      };
      fetchUnidades({
        newPagination: d,
      });
      return d;
    });
  };

  const fetchUnidades = ({
    newFilters,
    newPagination,
  }: {
    newFilters?: FiltrosUnidadeEnvio;
    newPagination?: typeof pagination;
  }) => {
    if (newFilters) setFilters(newFilters);

    const body = {
      ...(newFilters || filters),
      pagina: newPagination?.paginaAtual || pagination.paginaAtual,
      registros:
        newPagination?.totalItensRetorno || pagination.totalItensRetorno,
      authToken,
    };

    setLoading(true);

    postRevendaUnidadeListar(body)
      .then(({ success, data, notifications }) => {
        if (success) {
          setData(data?.response);
          setPagination((prev) => ({
            ...prev,
            paginaAtual: data?.pagina || 1,
            countTotalPagination: Math.ceil(
              (data?.totalRegistros || 0) / data?.registros
            ),
          }));
        } else throw new Error(notifications?.[0]?.message ?? "");
      })
      .catch((error) => {
        console.error(error);
        setData([]);
        setPagination({
          paginaAtual: 1,
          totalItensRetorno: 10,
          countTotalPagination: 1,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Container>
      <S.Header>
        <div className="group">
          <SearchBar
            value={filters.nome}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, nome: e?.target?.value ?? "" }))
            }
            handleBtnSearch={handleSearch}
            variant="outlined"
            style={{ width: 360 }}
            tooltip="Informe um Nome de Usuário, Unidade, Torre ou Empreendimento"
          />
          <Tooltip followCursor title="Abrir Filtro" placement="top" arrow>
            <S.OnPress
              onClick={() => setOpen((prev) => ({ ...prev, filters: true }))}
              style={{ background: "#2D5BFF" }}
            >
              <BsFilter color="#FFFFFF" />
              {filtersSelected > 0 && (
                <S.FiltersCount>{filtersSelected}</S.FiltersCount>
              )}
            </S.OnPress>
          </Tooltip>
        </div>

        <Button
          style={{
            background: "#2D5BFF",
            color: "#FFFFFF",
            height: 36,
            borderRadius: 8,
            boxShadow: "none",
            textTransform: "none",
          }}
          variant="contained"
          onClick={() => setOpen((prev) => ({ ...prev, novaRevenda: true }))}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <HiPlus size={16} />
            {"Nova Revenda"}
          </div>
        </Button>
      </S.Header>

      <S.Table>
        <S.Content>
          <S.TableContainer>
            <S.TableBody>
              <S.TableHeader>
                <p>{"Empreendimento"}</p>
                <p>{"Torre"}</p>
                <p>{"Andar"}</p>
                <p>{"Unid."}</p>
                <p>{"Área útil"}</p>
                <p>{"Vagas"}</p>
                <p>{"Valor"}</p>
                <p>{"Status"}</p>
                <p>{"Alteração"}</p>
                <p>{"Chave"}</p>
                <p>{"Responsável"}</p>
                <p style={{ textAlign: "center" }}>{"Ações"}</p>
              </S.TableHeader>

              <S.TableContent>
                {loading ? (
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 6 }}
                  >
                    {[0, 1, 2, 3, 4].map((item) => (
                      <Skeleton
                        key={item}
                        variant="rectangular"
                        height={38}
                        width="100%"
                      />
                    ))}
                  </div>
                ) : data?.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      padding: 16,
                      justifyContent: "center",
                    }}
                  >
                    <p>{"Nenhum resultado encontrado"}</p>
                  </div>
                ) : (
                  data?.map((item, index) => (
                    <S.TableItem
                      key={item?.id}
                      first={index === 0}
                      background={index % 2 === 0 ? "#fbfcff" : "white"}
                    >
                      <p>{item?.revendaEmpreendimento?.nome ?? "--"}</p>
                      <p>
                        {item?.revendaEmpreendimentoTorre?.descricao ?? "--"}
                      </p>
                      <p>{item?.andar ?? "--"}</p>
                      <p>{item?.unidade ?? "--"}</p>
                      <p>{item?.areaUtil ? `${item?.areaUtil} m²` : "--"}</p>
                      <p>{item?.vagas?.length ?? "--"}</p>
                      <p>{formatCurrency(item?.valorUnidade)}</p>
                      <p>
                        {item?.revendaStatus
                          ? StatusReserva[item?.revendaStatus]
                          : "--"}
                      </p>
                      <p>
                        {item?.dataAtualizacao
                          ? new Date(item?.dataAtualizacao).toLocaleDateString(
                              "pt-BR"
                            )
                          : "--"}
                      </p>
                      <p>{formatBoolean(item?.chaves)}</p>
                      <p>{item?.usuarioResponsavel ?? "--"}</p>
                      {loadingEdit === item?.id ? (
                        <Loading size={20} />
                      ) : (
                        <IconButton
                          onClick={() => {
                            handleEdit(item?.id);
                          }}
                          disableRipple
                          disabled={loadingEdit !== ""}
                          sx={{ padding: 0 }}
                        >
                          <MdOutlineEdit
                            size={22}
                            color={loadingEdit !== "" ? "#C4C4C4" : "#2196F3"}
                          />
                        </IconButton>
                      )}
                    </S.TableItem>
                  ))
                )}
              </S.TableContent>
            </S.TableBody>
          </S.TableContainer>
        </S.Content>

        <FooterTableEmpreendimentosRevenda
          onData={(d) => {
            setPagination((prev) => {
              const d_ = {
                ...prev,
                paginaAtual: d.PaginaAtual || 1,
                totalItensRetorno: d.TotalItensRetorno || 10,
              };
              if (
                d.PaginaAtual !== prev.paginaAtual ||
                d.TotalItensRetorno !== prev.totalItensRetorno
              ) {
                fetchUnidades({ newPagination: d_ });
              }
              return d_;
            });
          }}
          PaginaAtual={pagination.paginaAtual}
          TotalItensRetorno={pagination.totalItensRetorno}
          countTotalPagination={pagination.countTotalPagination}
        />
      </S.Table>
      {/* miscellaneous */}
      <S.SwipeableDrawer
        open={open.filters}
        anchor="right"
        onClose={() => setOpen((prev) => ({ ...prev, filters: false }))}
        onOpen={() => setOpen((prev) => ({ ...prev, filters: true }))}
      >
        <FiltroUnidadesRevenda
          open={open.filters}
          handleFilters={handleFilters}
          onClose={() => setOpen((prev) => ({ ...prev, filters: false }))}
          authToken={authToken}
        />
      </S.SwipeableDrawer>
      <NovaRevendaModal
        open={open.novaRevenda}
        onClose={() => {
          setOpen((prev) => ({ ...prev, novaRevenda: false }));
          setEdit(null);
        }}
        refetch={() => fetchUnidades({})}
        edit={edit}
        authToken={authToken}
      />
    </S.Container>
  );
};
